import { IconButton } from "@mui/material";

import { StraightenIcon } from "@/shared/foundation/icons/mui";

import type { ToolMode } from "./BabylonManager";

/**
 * Names both halves of what the tool does, because one activation gets the
 * user both: hovering reads out the coordinates under the cursor, clicking
 * measures between two of them.
 */
const LABEL = "Measure and inspect 3D points";
const EXIT_TITLE = "Exit measure and inspect";

interface MeasureToggleButtonProps {
  /** The panel's tool mode. The button is pressed while it is `"measure"`. */
  mode: ToolMode;
  onChange: (mode: ToolMode) => void;
  /** Set while the scene manager is not built yet, so there is nothing to pick against. */
  disabled?: boolean;
}

/**
 * Header button that turns the 3D panel's pointer tool on and off. Purely
 * presentational: the mode lives in `ThreeDPanel` state rather than panel
 * config, because it is a transient interaction mode, not part of a
 * shareable layout.
 */
export function MeasureToggleButton({
  mode,
  onChange,
  disabled = false,
}: MeasureToggleButtonProps) {
  const active = mode === "measure";
  return (
    <IconButton
      aria-label={LABEL}
      aria-pressed={active}
      disabled={disabled}
      onClick={() => onChange(active ? "none" : "measure")}
      size="small"
      title={active ? EXIT_TITLE : LABEL}
    >
      <StraightenIcon color={active ? "primary" : "inherit"} fontSize="small" />
    </IconButton>
  );
}
